import { _init_virtual_device_actions } from 'src/components/Scenes/helpers/virtual_components/virtual_device_actions';
import { get_mode, isPill, isCctOnlyDevice } from '../../../../../../helpers/interface_helpers';
import { _init_device_actions_v2 } from '../../../../helpers/init_device_actions';
import {
	format_gen2_addons_for_scenes,
	getAddonStatus,
	hasAddonPeripherals,
} from 'src/helpers/addons/addon_helpers';
import { isXT1Module } from 'src/helpers/xt1_helpers/template_helpers';
import { init_xt1_device_actions } from 'src/components/Scenes/helpers/virtual_components/xt1_device_scenes_helpers';

/**
 * Initialize action components for a device
 * @param {Object} device - The device object
 * @param {Object} status - The device status
 * @param {Object} settings - The device settings
 * @returns {Array} Array of action components
 */
export const _init_action_components_v2 = (device, status, settings) => {
	const { id, category, type } = device;
	let gen = device.gen == 2 ? 2 : 1;
	let mode,
		addOns = {};
	if (isXT1Module(device?.type)) {
		return init_xt1_device_actions(device);
	}
	if (status && settings) {
		mode = get_mode(device, status, settings);
	}

	if (category === 'emeter' && hasAddonPeripherals(device)) {
		addOns = format_gen2_addons_for_scenes(getAddonStatus(device));
	}

	let arr = [];

	/**
	 * Handle module devices that are CCT-only devices (like S3MX) as lights.
	 * These devices are always in CCT mode, so treat them as lights.
	 * @type {boolean}
	 */
	const isModuleCctLight = category === 'module' && isCctOnlyDevice(type);

	/**
	 * For CCT-only devices, default to 'cct' mode if mode isn't available
	 */
	if (isModuleCctLight && !mode) {
		mode = 'cct';
	}

	switch (category) {
		case 'pv':
			return _init_device_actions_v2[category]();
		case 'module':
			/**
			 * If module is a CCT-only device, treat it as a light
			 */
			if (isModuleCctLight) {
				return _init_device_actions_v2['light'](
					type,
					mode || 'cct',
					device.gen,
					device?.mode || 'cct',
				);
			}
		case 'lock':
			return _init_device_actions_v2[category]();
		case 'relay':
			return _init_device_actions_v2[category](gen, type);
		case 'emeter':
			return _init_device_actions_v2[category](gen, type, addOns);
		case 'roller':
			return _init_device_actions_v2[category](gen, type, device, settings);
		case 'light':
			return _init_device_actions_v2[category](type, mode, device.gen, device?.mode);
		case 'thermostat':
			return _init_device_actions_v2[category](type, settings, device);
		case 'breaker':
			return _init_device_actions_v2[category](gen, type);
		case 'virtual_device':
			return _init_virtual_device_actions(device?.channel, status, settings);
		case 'diffuser':
			/**Just a hint for scenes
			 * ciX => cury inensity left/right
			 * clX => cury level left/righ
			 * cae => cury ambient enable
			 * cab => cury ambient brightnes
			 * cac_X => cury ambient color red/green/blu
			 * ca => cury ambient to allow  {"r":"dev:...:ca", "set":{"_isdata":true,"cae":true,"cab":22,"cac_red":11,"cac_green":22,"cac_blue":33}}
			 */
			return _init_device_actions_v2[category](type);
		case 'media_player':
			return _init_device_actions_v2[category]();
		case 'camera':
			return _init_device_actions_v2[category]();
		case 'fan':
			return _init_device_actions_v2[category]();
		default:
			if (isPill(device.type)) {
				addOns = format_gen2_addons_for_scenes(getAddonStatus(device));
				return _init_device_actions_v2['addons'](device.type, addOns);
			}
			return arr;
	}
};
